import { Origin } from "@/openapi/generated";

/** Human-readable label for API `Origin` on reads (payments, makeups, enrollments). */
export function formatOriginLabel(origin: Origin | string | null | undefined): string {
  if (origin == null || origin === "") return "—";
  switch (origin) {
    case Origin.Admin:
      return "Admin portal";
    case Origin.Staff:
      return "Staff portal";
    case Origin.Teacher:
      return "Teacher portal";
    case Origin.Member:
      return "Parent portal";
    default:
      return String(origin);
  }
}
